import { __decorate } from "tslib";
import { LitElement, html } from 'lit';
import { property } from 'lit/decorators.js';
import '../typography/tg-body-two';
import styles from './styles';
/**
 * @dependency amityeko-tg-body-two
 *
 */
export default class AmityekoCharacterCounter extends LitElement {
    render() {
        return html `<div part="base">
      <amityeko-tg-body-two part="current-count">${this.currentCount}</amityeko-tg-body-two>
      <amityeko-tg-body-two part="slash">/</amityeko-tg-body-two>
      <amityeko-tg-body-two part="total-count">${this.totalCount}</amityeko-tg-body-two>
    </div>`;
    }
}
AmityekoCharacterCounter.styles = styles;
__decorate([
    property({ type: Number })
], AmityekoCharacterCounter.prototype, "currentCount", void 0);
__decorate([
    property({ type: Number })
], AmityekoCharacterCounter.prototype, "totalCount", void 0);
if (!customElements.get('amityeko-character-counter')) {
    customElements.define('amityeko-character-counter', AmityekoCharacterCounter);
}
//# sourceMappingURL=index.js.map